export const globalConfigs = {
  publicApiBaseUrl:
    process.env.REACT_APP_BASE_API_URL ??
    "https://apollo2be.schoolcento.com/apollo2",
  urlSSOLms: process.env.REACT_APP_LINK_SSO ?? "https://apollo.huynn.asia",
  apiKeySSO:
    process.env.REACT_APP_X_API_KEY ??
    "d24172ecbee858d9b6925bfbd852d43d9b2da4a14d6ac1821805bbe4542c04fc",
}
